import { Checkbox, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { useState } from 'react';
import { Row } from '~/commonComponents';
import ConfirmPopup from '~/components/shared/ConfirmPopup';
import { Links } from '~/constants';

interface IAchAuthorizationPopupProps {
  onConfirm: () => void;
}

export function AchAuthorizationPopup({ onConfirm }: IAchAuthorizationPopupProps) {
  const [isChecked, setIsChecked] = useState(false);

  const handleConfirm = () => {
    onConfirm();
    setIsChecked(false);
  };

  return (
    // @ts-expect-error ConfirmPopup is a JS file
    <ConfirmPopup
      dismissiblePopup={false}
      title="ACH Authorization Mandate"
      rightButtonText="Confirm"
      rightButtonDisabled={!isChecked}
      rightButtonAction={handleConfirm}
      dataTestId="ach-authorization-popup"
      dataCy="ach-authorization-popup"
      rightButtonDataCy="ach-confirm-button"
    >
      <Row marginBottom={32} paddingHorizontal={20} width={400} gap={12} alignItems="flex-start">
        <Checkbox checked={isChecked} onChange={setIsChecked} style={{ marginTop: 3 }} />
        <Typography as="span" color={colors.neutral[500]} textAlign="left">
          I authorize GoTu to electronically debit my account and, if necessary, electronically
          credit my account to correct erroneous debits. For full details, review GoTu&apos;s{' '}
          <a
            href={Links.termsOfUse}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: colors.secondary[500],
              fontWeight: 'bold',
              textDecoration: 'underline',
            }}
          >
            Terms of Service
          </a>
          .
        </Typography>
      </Row>
    </ConfirmPopup>
  );
}
